import { IDealsBannerText, TDealsBannerConfig } from '../../types/dealsBannerConfig';

/**
 * Возвращает текст баннера DealsBanner для статьи, если она есть в RS
 * dealsBannerConfig.
 */
export const getDealsBannerText = (
  postId: number,
  dealsBannerConfig: TDealsBannerConfig | null,
): IDealsBannerText | undefined => {
  if (dealsBannerConfig === null) {
    return undefined;
  }

  return dealsBannerConfig.find(group => group.postIds.includes(postId));
};
